import React, { useState, useMemo } from 'react';

const itemsPerPage = 10;

function TradeTable({ accounts, trades, selectedAccount, setTrades }) {
  const [currentPage, setCurrentPage] = useState(1);

  // 过滤和排序
  const filteredTrades = useMemo(() => {
    let t = selectedAccount
      ? trades.filter(trade => trade.account === selectedAccount)
      : trades;
    return [...t].sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [trades, selectedAccount]);

  // 分页
  const totalPages = Math.max(1, Math.ceil(filteredTrades.length / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredTrades.length);
  const currentPageTrades = filteredTrades.slice(startIndex, endIndex);

  // 删除交易
  const handleDelete = (indexInPage) => {
    if (window.confirm('确定要删除这条交易记录吗？')) {
      // 找到原 trades 中的索引
      const trade = currentPageTrades[indexInPage];
      const idx = trades.indexOf(trade);
      if (idx !== -1) {
        const newTrades = [...trades];
        newTrades.splice(idx, 1);
        setTrades(newTrades);
        // 如果当前页没有数据了，且不是第一页，则跳转到上一页
        if (currentPage > 1 && (currentPage - 1) * itemsPerPage >= newTrades.length) {
          setCurrentPage(currentPage - 1);
        }
      }
    }
  };

  // 切换页码时自动修正超出范围
  React.useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [totalPages, currentPage]);

  return (
    <div className="section">
      <h2>交易记录</h2>
      <table>
        <thead>
          <tr><th>账户</th><th>日期</th><th>品种</th><th>方向</th><th>仓位</th><th>入场</th><th>出场</th><th>盈亏</th><th>操作</th></tr>
        </thead>
        <tbody>
          {currentPageTrades.length === 0 ? (
            <tr><td colSpan="9">暂无交易记录</td></tr>
          ) : (
            currentPageTrades.map((trade, idx) => {
              const account = accounts.find(acc => acc.name === trade.account);
              const currency = account ? account.currency : '¥';
              return (
                <tr key={trade.account + trade.date + trade.instrument + idx}>
                  <td>{trade.account}</td>
                  <td>{trade.date}</td>
                  <td>{trade.instrument}</td>
                  <td>{trade.direction}</td>
                  <td>{trade.size}</td>
                  <td>{trade.entry}</td>
                  <td>{trade.exit}</td>
                  <td>{currency}{trade.profit.toFixed(2)}</td>
                  <td><button onClick={() => handleDelete(idx)}>删除</button></td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <div className="pagination" style={{ marginTop: 10, textAlign: 'center' }}>
        <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage <= 1} style={{ marginRight: 10 }}>上一页</button>
        <span style={{ margin: '0 10px' }}>第 {currentPage} 页，共 {totalPages} 页 (共 {filteredTrades.length} 条记录)</span>
        <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage >= totalPages} style={{ marginLeft: 10 }}>下一页</button>
      </div>
    </div>
  );
}

export default TradeTable; 